import { render } from "./TabBar.vue?vue&type=template&id=00b9cca8&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=js"
export * from "./TabBar.vue?vue&type=script&lang=js"

import "./TabBar.vue?vue&type=style&index=0&id=00b9cca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b9cca8"]])

export default __exports__